export class MessageBoxOptionsEnum {
    readonly name: string;
    readonly label: string;

    protected constructor(name: string, label: string) {
        this.name = name;
        this.label = label;
    }

    public static Inbox = new MessageBoxOptionsEnum("inbox", "my inbox");
    public static Sent = new MessageBoxOptionsEnum("sent", "my sent");
    public static AllMessages = new MessageBoxOptionsEnum(
        "all",
        "all messages"
    );

    public static asArray = () => [
        MessageBoxOptionsEnum.Inbox,
        MessageBoxOptionsEnum.Sent,
        MessageBoxOptionsEnum.AllMessages,
    ];

    public static fromName = (name: string) =>
        MessageBoxOptionsEnum.asArray().find(t => t.name === name);
}
